<template>
  <nuxt-link
    :to="{
      name: 'blog-post-page',
      params: {
        blogPostSlug: post.slug,
      },
    }"
    class="saas-blog-card"
    :class="{ 'saas-blog-card--horizontal': direction === 'horizontal' }"
  >
    <div class="saas-blog-card__image">
      <img
        v-if="!post.image"
        src="@saas/assets/images/image-364x272.png"
        alt="Blog placeholder image"
      />
      <img v-else :src="post.image" :alt="post.image_alt" />
    </div>
    <div class="saas-blog-card__content">
      <div class="saas-blog-card__title">
        {{ post.title }}
      </div>
      <p class="saas-blog-card__description">
        {{ post.description }}
      </p>

      <div class="saas-blog-card__meta">
        <div class="saas-blog-card__author">{{ post.author }}</div>
        <span class="saas-blog-card__meta-circle"></span>
        <div class="saas-blog-card__date">
          {{ formatBlogPostDate(post.date) }}
        </div>
      </div>
    </div>
  </nuxt-link>
</template>

<script>
import moment from '@baserow/modules/core/moment'

export default {
  name: 'BlogPostCard',
  props: {
    post: {
      type: Object,
      required: true,
    },
    direction: {
      type: String,
      default: 'vertical',
      validator: (value) => ['vertical', 'horizontal'].includes(value),
    },
  },
  methods: {
    formatBlogPostDate(date) {
      return moment(date).format('MMMM D, YYYY')
    },
  },
}
</script>
